export default "__VITE_ASSET__BuOwVxvZ__"